'use strict';

function Interstitial() {
  this.id = null;
  this.node = null;
  this.extends = [];

  this.contentType = 'interstitial';
  this.contentId = ''; // contentId defined in pug file

  this.elements = {};

  this.initInterstitial = function () {
    this.contentRef = 'content.' + this.contentType + '.' + this.contentId;
    this._product = new Product(this.contentRef, this.presenter, this.node);

    if (this._product.valid) {
      this.analytics.pushEvent('virtual-page-view');
      this._product.pushContentfulAnalyticsEvent();
      // content elements:
      this.elements.media = this.node.querySelector('.js--media');
      this.elements.primaryCta = this.node.querySelector('.js--primary-cta');

      // load required components:
      this._product.loadMedia(this.elements.media, {
        autoplay: false
      });

      // make the look of the button but do no action
      var noop = function noop() {};
      this._product.loadPrimaryCta(this.elements.primaryCta, 'nav-action-1', noop);

      // do the action _after_ content has been marked as read
      this.elements.primaryCta.addEventListener('click', this.markAsViewed.bind(this, this.contentId + '-' + this.contentType));
    }
  };

  this.markAsViewed = function (target) {
    this._productSettings.createViewedContent(target, this.goToThePage.bind(this));
  };

  this.goToThePage = function (data, response) {
    var targetId = this._product.getTargetId(this._product._contentModel.primaryCta.configuration, 'nav-action-1');
    this._product.gotoTarget(targetId);
  };

  this.destroyInterstitial = function () {
    if (this._product) {
      this._product.destroy();
    }
  };

  // Template file is not first component extended so don't use these
  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}